import { MpcGetTripsResponseDto } from '@/features/trips/MpcGetTripsResponseDto';
import { PassingTime } from '@/features/trips/PassingTime';
import { Trip } from '@/features/trips/Trip';
import { BookingData, BookingNoShowPage, DeleteBookingNoShowRequest } from './BookingNoShowModels';

export const ITripServiceId = Symbol.for('ITripService');

export interface ITripService {
    getTrips(linePublicCode: string, calendarDay?: string): Promise<MpcGetTripsResponseDto>;

    createTrip(tripId: string, calendarDay: string): Promise<void>;

    updateTrip(trip: Trip): Promise<any>;

    updatePassingTime(trip: Trip, passingTime: PassingTime, timeStamp: number): Promise<any>;

    registerBookingNoShow(bookingData: BookingData): Promise<any>;

    deleteBookingNoShow(request: DeleteBookingNoShowRequest): Promise<void>;

    getBookingNoShowList(page: BookingNoShowPage, filters: any): Promise<any>;

    completeTrip(tripId: string, operatingDay: string): Promise<void>;

    cancelTrip(tripId: string, operatingDay: string): Promise<void>;
}
